import { InputHTMLAttributes } from "react";
import JsonView from "@uiw/react-json-view";

export function JsonViewer({
  data = { data: "No data to display" },
  onEdit,
  onAdd,
  ...props
}: {
  data?: any;
  onEdit?: (e: any) => void;
  onAdd?: (e: any) => void;
} & Omit<InputHTMLAttributes<HTMLInputElement>, "onChange">) {
  return (
    <div className="z-0 h-full w-full">
      <JsonView
        value={data}
        style={{ minHeight: "100%", width: "100%" }}
        // iconStyle="circle"
        enableClipboard={true}
        // onEdit={onEdit ? onEdit : false}
        displayDataTypes={false}
        displayObjectSize={false}
        // onAdd={onAdd ? onAdd : false}
        indentWidth={4}
        collapsed={1}
        // collapseStringsAfterLength={25}
        // name={false}
      />
    </div>
  );
}
